import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Table, Input, Checkbox, Button, Dropdown} from 'semantic-ui-react';
import {Actions} from '../../../../common/actions';
import {warranties} from '../../../constants';
import {enterKeyCode, tabKeyCode} from '../../../../common/constants/keyCodes';
import {getTotalColumn, validateUnique, falsePrincipalPart, parseTasksOptions} from '../../../utils';

const FormWork = (props) => {
  const {taskId, hours, principalTask, description, handleChange, handleSelectionChange,
    handleAddItem, handleCheckBox, handleKeyDown, loading, campaignTasks, campaignFlag} = props;
  const validateBtn = description === '' || hours <= 0;

  return (
    <Table.Row>
      <Table.Cell>
        <Checkbox
          disabled={loading}
          label='¿Es operación manual ?'
          checked={principalTask}
          onChange={handleCheckBox}/>
      </Table.Cell>
      <Table.Cell>
        {campaignFlag && campaignTasks && campaignTasks.length > 0 ? (
          <Dropdown
            selection
            search
            placeholder='No.Operación'
            options={parseTasksOptions(campaignTasks)}
            value={taskId}
            onChange={handleSelectionChange}
          />) : (
          <Input
            disabled={loading}
            className='twc-works-input'
            placeholder='No.Operación'
            value={taskId}
            onKeyDown={handleKeyDown}
            onChange={(e, {value}) => handleChange('taskId', value)} />
        )}
      </Table.Cell>
      <Table.Cell>
        {description}
      </Table.Cell>
      <Table.Cell>
        <Input
          disabled={loading}
          className='twc-works-input'
          value={hours}
          type='number'
          min='0'
          onChange={(e, {value}) => handleChange('hours', value)}
        />
      </Table.Cell>
      <Table.Cell>
        {warranties.hour_price}
      </Table.Cell>
      <Table.Cell>{hours * warranties.hour_price}</Table.Cell>
      <Table.Cell>
        <Button
          disabled={validateBtn}
          onClick={() => handleAddItem()}
          size='mini'
          color='green'>
            Agregar
        </Button>
      </Table.Cell>
    </Table.Row>
  );
};


const DisplayData = ({item, handleRemoveItem, id, handleUpdatePrincipalWorks, handleUpdateAmount, disabledBtns}) => {
  const {taskId, hours, principalTask, description} = item;
  return (
    <Table.Row>
      <Table.Cell>
        <Checkbox
          disabled={disabledBtns}
          onChange={(e, data) => handleUpdatePrincipalWorks(e, data, item)}
          checked={principalTask === 'S'}
        />
      </Table.Cell>
      <Table.Cell>{taskId}</Table.Cell>
      <Table.Cell>{description}</Table.Cell>
      <Table.Cell>
        <Input
          className='twc-works-input'
          value={hours}
          type='number'
          min='0'
          onChange={(e, {value}) => handleUpdateAmount('hours', value, item)}
        />
      </Table.Cell>
      <Table.Cell>{warranties.hour_price}</Table.Cell>
      <Table.Cell>$ {hours * warranties.hour_price}</Table.Cell>
      <Table.Cell>
        <Button
          disabled={disabledBtns}
          onClick={() => handleRemoveItem(id)}
          size='mini'
          color='red'
        >
          Eliminar
        </Button>
      </Table.Cell>
    </Table.Row>
  );
};


const initialState = {
  'taskId': '',
  'hours': 0.0,
  'principalTask': false,
  'description': '',
  'total': 0.0,
};

class Work extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ...initialState,
    };
  }

  componentDidUpdate(prevProps) {
    const {job} = this.props;

    if (prevProps.job !== job && job.description !== '') {
      this.setState({
        'description': job.description,
      });
    }
  }

  handleAddItem = () => {
    const {handleChangeForm} = this.props;
    const {taskId, hours, principalTask, description} = this.state;
    const newJobs = [...this.props.jobs];
    const item = {
      taskId,
      'hours': +hours,
      'principalTask': principalTask ? 'S' : 'N',
      description, 'total': hours * warranties.hour_price,
    };

    if (validateUnique(newJobs, 'taskId', taskId)) {
      const jobs = principalTask ? falsePrincipalPart(newJobs, 'principalTask') : newJobs;
      jobs.push(item);
      this.setState({
        ...initialState,
      }, () => {
        handleChangeForm('jobs', jobs);
      });
    } else {
      this.props.addMessageBoxError(`El item ${taskId} ya se encuentra en la lista`);
    }
  }

  handleRemoveItem = (id) => {
    const {handleChangeForm} = this.props;
    const jobs = [...this.props.jobs].filter((item, idx) => idx !== id);
    handleChangeForm('jobs', jobs);
  }

  handleCheckBox = (event, data) => {
    this.setState({
      'principalTask': data.checked,
    });
  }

  handleChange = (field, value) => {
    this.setState({
      [field]: value,
      'description': field === 'taskId' ? '' : this.state.description,
    });
  }

  handleSelectionChange = (e, {value}) => {
    const {campaign} = this.props;
    const selectedOption = campaign.tasksArray.find((task) => task.taskId === value);
    this.setState({
      'taskId': selectedOption.taskId,
      'hours': 0,
      'description': selectedOption.description,
      'total': 0 * warranties.hour_price,
    });
  };

  handleKeyDown = (e) => {
    const {taskId} = this.state;
    if (e.keyCode === enterKeyCode || e.keyCode === tabKeyCode) {
      if (taskId.length > 1) {
        this.props.getWarrantyJobById(taskId);
      }
    }
  }

  handleUpdatePrincipalWorks = (event, data, selectItem) => {
    const {jobs, handleChangeForm} = this.props;
    const updatePrincipalJobs = jobs.map((item) => {
      if (item.taskId === selectItem.taskId) {
        return {
          ...selectItem,
          'principalTask': data.checked ? 'S' : 'N',
        };
      }
      return {
        ...item,
        'principalTask': 'N',
      };
    });
    handleChangeForm('jobs', updatePrincipalJobs);
  }

  handleUpdateAmount = (field, value, selectItem) => {
    const {jobs, handleChangeForm} = this.props;
    const updatePrincipalJobs = jobs.map((item) => {
      if (item.taskId === selectItem.taskId) {
        return {
          ...selectItem,
          [field]: +value,
          'total': +value * warranties.hour_price,
        };
      }
      return item;
    });
    handleChangeForm('jobs', updatePrincipalJobs);
  };

  render() {
    const {loading, jobs, disabledBtns, campaign, campaignFlag} = this.props;

    return (
      <div>
        <div className='warranty-container-table'>
          <Table celled>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell> Ope. Manual</Table.HeaderCell>
                <Table.HeaderCell>No. de Operación</Table.HeaderCell>
                <Table.HeaderCell>Descripción</Table.HeaderCell>
                <Table.HeaderCell>Número de horas</Table.HeaderCell>
                <Table.HeaderCell>Valor por hora</Table.HeaderCell>
                <Table.HeaderCell>Valor</Table.HeaderCell>
                <Table.HeaderCell></Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {!disabledBtns && (
                <FormWork
                  handleChange={this.handleChange}
                  {...this.state}
                  handleAddItem={this.handleAddItem}
                  handleCheckBox={this.handleCheckBox}
                  handleKeyDown={this.handleKeyDown}
                  handleSelectionChange={this.handleSelectionChange}
                  loading={loading}
                  campaignTasks={campaign?.tasksArray}
                  campaignFlag={campaignFlag}
                />
              )}
              {jobs.map((job, idx) => (
                <DisplayData
                  disabledBtns={disabledBtns}
                  key={idx}
                  item={job}
                  id={idx}
                  handleUpdatePrincipalWorks={this.handleUpdatePrincipalWorks}
                  handleUpdateAmount={this.handleUpdateAmount}
                  handleRemoveItem={this.handleRemoveItem}
                />
              ))}
              <Table.Row className='warranty-table-footer'>
                <Table.Cell> </Table.Cell>
                <Table.Cell> </Table.Cell>
                <Table.Cell>SUBTOTAL</Table.Cell>
                <Table.Cell>{getTotalColumn(jobs, 'hours')} </Table.Cell>
                <Table.Cell> </Table.Cell>
                <Table.Cell>$ {getTotalColumn(jobs, 'total')}</Table.Cell>
                <Table.Cell> </Table.Cell>
              </Table.Row>
            </Table.Body>
          </Table>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'permissions': state.session.permissions,
    'loading': state.warrantiesCategories.loading,
    'job': state.warrantiesCategories.job,
    'campaign': state.campaign.campaign,
  };
};

const {getWarrantyJobById, addMessageBoxError} = Actions;

export default connect(mapStateToProps, {
  getWarrantyJobById,
  addMessageBoxError,
})(Work);

